import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-noauthroized',
  templateUrl: './noauthroized.component.html',
  styleUrls: ['./noauthroized.component.css']
})
export class NoauthroizedComponent implements OnInit {

  constructor(private __router: Router) { }

  ngOnInit(): void {
    let usEnc = localStorage.getItem('user');
    if (usEnc == null) {
        this.__router.navigate(['/']);
    }
  }

}
